/**
 * PATH: packages/ui/src/lib/inputDisplay.ts
 * FILE_ID: UI-LIB-INPUT-DISPLAY-001
 * PURPOSE: Display class for a styled <input>, by type.
 * WHY: `display: flex` on a native date/time input lays out its shadow parts as
 *      flex items, so Chrome draws the calendar icon right after the text, mid
 *      field. Picker types need `block`; others keep `flex` (file inputs style
 *      their button with it). Imported by the master, CFO and @quotech/ui
 *      Inputs through the `@quotech/ui/lib/inputDisplay` subpath, not the root
 *      barrel, because many tests mock `@quotech/ui` wholesale.
 */

const PICKER_INPUT_TYPES = new Set(['date', 'time', 'datetime-local', 'month', 'week'])

/** f(input type) -> 'block' for native picker types, else 'flex'. */
export function inputDisplayClass(type?: string | null): 'block' | 'flex' {
  return type && PICKER_INPUT_TYPES.has(type) ? 'block' : 'flex'
}
